import { EnergyLabels } from '@shared/constants';

export interface SuggestionStreetModel {
  readonly street: string;
  readonly city: string;
  readonly type: SuggestionType.Street;
  readonly energyLabel?: EnergyLabels;
}

export interface SuggestionAddressModel {
  readonly street: string;
  readonly city: string;
  readonly type: SuggestionType.Address;
  readonly number: string;
  readonly postalcode: string;
  readonly addressId: string;
  readonly energyLabel?: EnergyLabels;
}

export enum SuggestionType {
  Street = 'STREET',
  Address = 'ADDRESS',
  Undefined = 'UNDEFINED'
}
